exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-695a2982]:root {\n  --reflex-columns: 12;\n  --reflex-grid-spacing: 15px;\n  --reflex-xs: 576px;\n  --reflex-sm: 768px;\n  --reflex-md: 992px;\n  --reflex-lg: 1200px;\n  --reflex-xlg: 1600px;\n  --reflex-xxs-max: 575px;\n  --reflex-xs-max: 767px;\n  --reflex-sm-max: 991px;\n  --reflex-md-max: 1199px;\n  --reflex-lg-max: 1599px;\n}\n.forgot[data-v-695a2982] {\n  position: absolute;\n  right: 0;\n  top: 0;\n  font-size: 1.2rem;\n}", ""]);

// exports
